import React from 'react';
import { i18next } from 'wix-rich-content-common';
import ContentViewer from './ContentViewer.js';
import 'classnames';
import 'lodash';
import 'ricos-styles';
import '../ContentTraverser-08f53479.js';
import 'ricos-context';
import './rericos/decorators/index.js';
import 'ricos-common-plugins/viewer';
import './rericos/decorators/breakoutDecorator.js';
import './rericos/decorators/nodeViewDecorators.js';
import './rericos/renderers/index.js';
import 'ricos-schema';
import './rericos/renderers/blockquote/blockquote.js';
import '../indentation-e83bdb4e.js';
import './rericos/utils/Anchorable.js';
import './rericos/utils/paywallSeo.js';
import './rericos/renderers/consts.js';
import './rericos/renderers/codeblock/codeblock.js';
import '../alignment.rtlignore-5b2a79a8.js';
import './rericos/renderers/heading/heading.js';
import './rericos/renderers/lists/bulletedList.js';
import '../lists-791021fb.js';
import './rericos/renderers/lists/listItem.js';
import 'ricos-types';
import './rericos/renderers/lists/getStartMargin.js';
import './rericos/renderers/lists/orderedList.js';
import './rericos/renderers/paragraph/paragraph.js';
import './rericos/renderers/text/text.js';
import './rericos/renderers/plugins/getPluginRenderers.js';
import './rericos/renderers/plugins/fromExternalNode.js';
import 'ricos-content/libs/struct-converters';
import '../getClassNames-7e031f0a.js';
import './rericos/renderers/plugins/nodeViewContainer.js';
import './components/ErrorBoundary.js';
import './rericos/renderers/plugins/ContainerElement.js';
import './rericos/utils/SpoilerManager.js';
import './RicosNodesRenderer.js';
import './components/Anchor.js';
import './components/AddAnchors.js';

var ar = {
	VerticalEmbed_Products_Button: "شراء الآن",
	VerticalEmbed_Events_Button: "تسجيل الآن",
	VerticalEmbed_Bookings_Button: "حجز الآن",
	UploadFile_Viewer_Download: "تنزيل {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} س",
	VerticalEmbed_Units_Minute: "{{minutes}} د"
};
var bg = {
	VerticalEmbed_Products_Button: "Купете сега",
	VerticalEmbed_Events_Button: "Регистрирайте се сега",
	VerticalEmbed_Bookings_Button: "Резервирайте сега",
	UploadFile_Viewer_Download: "Изтегляне на {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}}ч.",
	VerticalEmbed_Units_Minute: "{{minutes}}мин."
};
var ca = {
	VerticalEmbed_Products_Button: "Compra ara",
	VerticalEmbed_Events_Button: "Registra't ara",
	VerticalEmbed_Bookings_Button: "Reserva ara",
	UploadFile_Viewer_Download: "Baixa {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} h",
	VerticalEmbed_Units_Minute: "{{minutes}} min"
};
var cs = {
	VerticalEmbed_Products_Button: "Koupit",
	VerticalEmbed_Events_Button: "Registrovat",
	VerticalEmbed_Bookings_Button: "Rezervovat",
	UploadFile_Viewer_Download: "Stáhnout {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} h",
	VerticalEmbed_Units_Minute: "{{minutes}} min"
};
var da = {
	VerticalEmbed_Products_Button: "Køb nu",
	VerticalEmbed_Events_Button: "Tilmeld dig",
	VerticalEmbed_Bookings_Button: "Book nu",
	UploadFile_Viewer_Download: "Download {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} t",
	VerticalEmbed_Units_Minute: "{{minutes}} min"
};
var de = {
	VerticalEmbed_Products_Button: "Jetzt kaufen",
	VerticalEmbed_Events_Button: "Jetzt anmelden",
	VerticalEmbed_Bookings_Button: "Jetzt buchen",
	UploadFile_Viewer_Download: "{{fileType}} herunterladen",
	VerticalEmbed_Units_Hour: "{{hours}} Std.",
	VerticalEmbed_Units_Minute: "{{minutes}} Min."
};
var el = {
	VerticalEmbed_Products_Button: "Αγορά τώρα",
	VerticalEmbed_Events_Button: "Εγγραφείτε τώρα",
	VerticalEmbed_Bookings_Button: "Κάντε κράτηση τώρα",
	UploadFile_Viewer_Download: "Λήψη {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}}ω",
	VerticalEmbed_Units_Minute: "{{minutes}} λεπτά"
};
var en = {
	Poll_Viewer_VoteCount_Modal_Voters_Header: "{{count}} person voted for this answer",
	Poll_Viewer_VoteCount_Modal_Voters_Header_plural: "{{count}} people voted for this answer",
	Poll_Viewer_VoteCount_Modal_Voters_Anonymous: "+{{anonNumber}} anonymous",
	Poll_Viewer_VoteCount_Modal_Voters_Private_Voter: "Private User",
	Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow: "Follow",
	Poll_Viewer_ShowAllOptions_CTA: "See All Options",
	Poll_Viewer_ShowAllResults_CTA: "See All Results",
	Poll_Viewer_ShowLess_CTA: "Show Less",
	Poll_Viewer_Visibility_Owner_Footer: "Only you can see the results.",
	Poll_Viewer_Multiselect_Footer: "You can vote for more than one answer.",
	Poll_Viewer_Toast_Error_Connection: "No internet. Check your connection.",
	Poll_Viewer_Toast_Error_ServerDown: "Couldn't connect to server. Try again later.",
	Poll_Viewer_VoteCount: "{{number}} votes",
	Poll_Viewer_Option_AriaLabel_Checked: "checked",
	Poll_Viewer_Option_AriaLabel_Unchecked: "unchecked",
	Audio_Plugin_Cover_Alt: "Audio cover",
	Polls_Plugin_User_Avatar_Alt: "User avatar",
	UploadFile_Viewer_Download: "Download {{fileType}}",
	UploadFile_Viewer_Loader: "Loading {{fileType}}",
	Viewer_Toolbar_Twitter_Tooltip: "Tweet this",
	Preview_ReadMore_Label: "Read more",
	Preview_SeeFullPost_Label: "See Full Post",
	Spoiler_Insert_Tooltip: "Spoiler",
	Spoiler_Reveal_Tooltip: "Click to reveal",
	Spoiler_Reveal_Image_Placeholder: "This image contains a spoiler",
	Spoiler_Reveal_Image_CTA: "Reveal Image",
	Spoiler_Reveal_Gallery_Placeholder: "This gallery contains a spoiler",
	Spoiler_Reveal_Gallery_CTA: "Reveal Gallery",
	Spoiler_Reveal_Video_Placeholder: "This video contains a spoiler",
	Spoiler_Reveal_Video_CTA: "Reveal Video",
	CollapsibleListPlugin_ExpandButton_AriaLabel: "Item is expanded",
	CollapsibleListPlugin_CollapseButton_AriaLabel: "Item is collapsed",
	VerticalEmbed_Bookings_Button: "Book Now",
	VerticalEmbed_Events_Button: "Register Now",
	VerticalEmbed_Products_Button: "Buy Now",
	VerticalEmbed_Disabled_Button_Tooltip: "Product page will be available once you publish your site.",
	VerticalEmbed_Units_Hour: "{{hours}}h",
	VerticalEmbed_Units_Minute: "{{minutes}}min"
};
var es = {
	VerticalEmbed_Products_Button: "Comprar ahora",
	VerticalEmbed_Events_Button: "Registrarse",
	VerticalEmbed_Bookings_Button: "Reservar ahora",
	UploadFile_Viewer_Download: "Descargar {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}}h",
	VerticalEmbed_Units_Minute: "{{minutes}}min"
};
var fi = {
	VerticalEmbed_Products_Button: "Osta nyt",
	VerticalEmbed_Events_Button: "Rekisteröidy nyt",
	VerticalEmbed_Bookings_Button: "Varaa nyt",
	UploadFile_Viewer_Download: "Lataa {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} t",
	VerticalEmbed_Units_Minute: "{{minutes}} min"
};
var fr = {
	VerticalEmbed_Products_Button: "Acheter",
	VerticalEmbed_Events_Button: "S'inscrire",
	VerticalEmbed_Bookings_Button: "Réserver",
	UploadFile_Viewer_Download: "Télécharger {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} h",
	VerticalEmbed_Units_Minute: "{{minutes}} min"
};
var he = {
	VerticalEmbed_Products_Button: "לקנייה",
	VerticalEmbed_Events_Button: "להרשמה",
	VerticalEmbed_Bookings_Button: "הזמינו עכשיו",
	UploadFile_Viewer_Download: "הורידו את {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} שעות",
	VerticalEmbed_Units_Minute: "{{minutes}} דקות"
};
var hi = {
	VerticalEmbed_Products_Button: "अभी खरीदें",
	VerticalEmbed_Events_Button: "अभी पंजीकरण करें",
	VerticalEmbed_Bookings_Button: "अभी बुक करें",
	UploadFile_Viewer_Download: "{{fileType}} डाउनलोड करें",
	VerticalEmbed_Units_Hour: "{{hours}}घंटे",
	VerticalEmbed_Units_Minute: "{{minutes}}मिनट"
};
var hu = {
	VerticalEmbed_Products_Button: "Vásárlás most",
	VerticalEmbed_Events_Button: "Regisztráció most",
	VerticalEmbed_Bookings_Button: "Foglalás most",
	UploadFile_Viewer_Download: "{{fileType}} letöltése",
	VerticalEmbed_Units_Hour: "{{hours}} óra",
	VerticalEmbed_Units_Minute: "{{minutes}} perc"
};
var id = {
	VerticalEmbed_Products_Button: "Beli Sekarang",
	VerticalEmbed_Events_Button: "Daftar Sekarang",
	VerticalEmbed_Bookings_Button: "Pesan Sekarang",
	UploadFile_Viewer_Download: "Unduh {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}}j",
	VerticalEmbed_Units_Minute: "{{minutes}}mnt"
};
var it = {
	VerticalEmbed_Products_Button: "Acquista",
	VerticalEmbed_Events_Button: "Registrati",
	VerticalEmbed_Bookings_Button: "Prenota",
	UploadFile_Viewer_Download: "Scarica {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} h",
	VerticalEmbed_Units_Minute: "{{minutes}} min"
};
var ja = {
	VerticalEmbed_Products_Button: "購入する",
	VerticalEmbed_Events_Button: "今すぐ登録",
	VerticalEmbed_Bookings_Button: "今すぐ予約",
	UploadFile_Viewer_Download: "ダウンロード：{{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}}時間",
	VerticalEmbed_Units_Minute: "{{minutes}}分"
};
var ko = {
	VerticalEmbed_Products_Button: "구매하기",
	VerticalEmbed_Events_Button: "등록하기",
	VerticalEmbed_Bookings_Button: "예약하기",
	UploadFile_Viewer_Download: "{{fileType}} 다운로드",
	VerticalEmbed_Units_Hour: "{{hours}}시간",
	VerticalEmbed_Units_Minute: "{{minutes}}분"
};
var lt = {
	VerticalEmbed_Products_Button: "Pirkti",
	VerticalEmbed_Events_Button: "Registruotis",
	VerticalEmbed_Bookings_Button: "Užsakyti",
	UploadFile_Viewer_Download: "Atsisiųsti {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} val.",
	VerticalEmbed_Units_Minute: "{{minutes}} min."
};
var ms = {
	VerticalEmbed_Products_Button: "Beli Sekarang",
	VerticalEmbed_Events_Button: "Daftar Sekarang",
	VerticalEmbed_Bookings_Button: "Tempah Sekarang",
	UploadFile_Viewer_Download: "Muat turun {{fileType}}",
	VerticalEmbed_Units_Hour: "{{jam}}j",
	VerticalEmbed_Units_Minute: "{{minit}}min"
};
var nl = {
	VerticalEmbed_Products_Button: "Nu kopen",
	VerticalEmbed_Events_Button: "Nu registreren",
	VerticalEmbed_Bookings_Button: "Nu boeken",
	UploadFile_Viewer_Download: "Download {{fileType}}",
	VerticalEmbed_Units_Hour: "{{uur}}u",
	VerticalEmbed_Units_Minute: "{{minuten}}min"
};
var no = {
	VerticalEmbed_Products_Button: "Kjøp nå",
	VerticalEmbed_Events_Button: "Registrer deg nå",
	VerticalEmbed_Bookings_Button: "Book nå",
	UploadFile_Viewer_Download: "Last ned {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}}t",
	VerticalEmbed_Units_Minute: "{{minutes}}min"
};
var pl = {
	VerticalEmbed_Products_Button: "Kup teraz",
	VerticalEmbed_Events_Button: "Zarejestruj się teraz",
	VerticalEmbed_Bookings_Button: "Zarezerwuj teraz",
	UploadFile_Viewer_Download: "Pobierz {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}}h",
	VerticalEmbed_Units_Minute: "{{minutes}}min"
};
var pt = {
	VerticalEmbed_Products_Button: "Compre agora",
	VerticalEmbed_Events_Button: "Registre-se agora",
	VerticalEmbed_Bookings_Button: "Agendar agora",
	UploadFile_Viewer_Download: "Fazer download de {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}}h",
	VerticalEmbed_Units_Minute: "{{minutes}}min"
};
var ro = {
	VerticalEmbed_Products_Button: "Cumpără acum",
	VerticalEmbed_Events_Button: "Înregistrează-te acum",
	VerticalEmbed_Bookings_Button: "Rezervă acum",
	UploadFile_Viewer_Download: "Descarcă {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} h",
	VerticalEmbed_Units_Minute: "{{minutes}} min"
};
var ru = {
	VerticalEmbed_Products_Button: "Купить",
	VerticalEmbed_Events_Button: "Зарегистрироваться",
	VerticalEmbed_Bookings_Button: "Забронировать",
	UploadFile_Viewer_Download: "Скачать {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} ч.",
	VerticalEmbed_Units_Minute: "{{minutes}} мин."
};
var sk = {
	VerticalEmbed_Products_Button: "Kúpiť teraz",
	VerticalEmbed_Events_Button: "Zaregistrujte sa teraz",
	VerticalEmbed_Bookings_Button: "Rezervovať teraz",
	UploadFile_Viewer_Download: "Stiahnuť {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}}h",
	VerticalEmbed_Units_Minute: "{{minutes}}min"
};
var sl = {
	VerticalEmbed_Products_Button: "Kupi zdaj",
	VerticalEmbed_Events_Button: "Registrirajte se zdaj",
	VerticalEmbed_Bookings_Button: "Rezerviraj zdaj",
	UploadFile_Viewer_Download: "Prenos {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}}h",
	VerticalEmbed_Units_Minute: "{{minutes}} min"
};
var sv = {
	VerticalEmbed_Products_Button: "Köp nu",
	VerticalEmbed_Events_Button: "Registrera dig nu",
	VerticalEmbed_Bookings_Button: "Boka nu",
	UploadFile_Viewer_Download: "Ladda ner {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} t",
	VerticalEmbed_Units_Minute: "{{minutes}} min"
};
var th = {
	VerticalEmbed_Products_Button: "ซื้อเลย",
	VerticalEmbed_Events_Button: "ลงทะเบียนตอนนี้",
	VerticalEmbed_Bookings_Button: "จองเลย",
	UploadFile_Viewer_Download: "ดาวน์โหลด {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} ชม.",
	VerticalEmbed_Units_Minute: "{{minutes}} นาที"
};
var tl = {
	VerticalEmbed_Products_Button: "Bumili Na",
	VerticalEmbed_Events_Button: "Magparehistro Na",
	VerticalEmbed_Bookings_Button: "Mag-book Na",
	UploadFile_Viewer_Download: "I-download ang {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}}h",
	VerticalEmbed_Units_Minute: "{{minutes}}min"
};
var tr = {
	VerticalEmbed_Products_Button: "Satın Al",
	VerticalEmbed_Events_Button: "Hemen Kaydol",
	VerticalEmbed_Bookings_Button: "Yer Ayırt",
	UploadFile_Viewer_Download: "{{fileType}} dosyasını indir",
	VerticalEmbed_Units_Hour: "{{hours}} sa.",
	VerticalEmbed_Units_Minute: "{{minutes}} dk."
};
var uk = {
	VerticalEmbed_Products_Button: "Купити зараз",
	VerticalEmbed_Events_Button: "Зареєструватися",
	VerticalEmbed_Bookings_Button: "Записатися",
	UploadFile_Viewer_Download: "Завантажити {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} год.",
	VerticalEmbed_Units_Minute: "{{minutes}} хв."
};
var vi = {
	VerticalEmbed_Products_Button: "Mua ngay",
	VerticalEmbed_Events_Button: "Đăng ký ngay",
	VerticalEmbed_Bookings_Button: "Đặt ngay",
	UploadFile_Viewer_Download: "Tải về {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} giờ",
	VerticalEmbed_Units_Minute: "{{minutes}} phút"
};
var zh = {
	VerticalEmbed_Products_Button: "立即購買",
	VerticalEmbed_Events_Button: "立即報名",
	VerticalEmbed_Bookings_Button: "立即預訂",
	UploadFile_Viewer_Download: "下載 {{fileType}}",
	VerticalEmbed_Units_Hour: "{{hours}} 小時",
	VerticalEmbed_Units_Minute: "{{minutes}} 分鐘"
};
var viewerVitalTranslations = {
	ar: ar,
	bg: bg,
	ca: ca,
	cs: cs,
	da: da,
	de: de,
	el: el,
	en: en,
	es: es,
	fi: fi,
	fr: fr,
	he: he,
	hi: hi,
	hu: hu,
	id: id,
	it: it,
	ja: ja,
	ko: ko,
	lt: lt,
	ms: ms,
	nl: nl,
	no: no,
	pl: pl,
	pt: pt,
	ro: ro,
	ru: ru,
	sk: sk,
	sl: sl,
	sv: sv,
	th: th,
	tl: tl,
	tr: tr,
	uk: uk,
	vi: vi,
	zh: zh
};

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const vitalTranslationsWithDefaults = addDefaultsFromEnglish(viewerVitalTranslations);
const TranslatedContentViewer = (props) => {
  const locale = props.locale;
  const [resourcesState, setResourcesState] = React.useState(() => {
    return {
      status: "READY",
      loadedLocales: ["en"],
      i18nextInstance: createI18nextInstance({
        activeLocale: locale,
        resources: vitalTranslationsWithDefaults
      })
    };
  });
  const { i18nextInstance, loadedLocales } = resourcesState;
  if (locale !== i18nextInstance.language) {
    i18nextInstance.changeLanguage(locale);
  }
  React.useEffect(() => {
    if (loadedLocales.includes(locale) || resourcesState.status !== "READY") {
      return;
    }
    setResourcesState((prevState) => __spreadProps(__spreadValues({}, prevState), { status: "LOADING" }));
    import(
      /* webpackChunkName: "ricos_viewer_messages_[request]" */
      `../../translations/locale/messages_${locale}.json`
    ).then((response) => response.default).then((localeResource) => {
      i18nextInstance.addResourceBundle(locale, "translation", localeResource, true, true);
      setResourcesState((prevState) => {
        return __spreadProps(__spreadValues({}, prevState), {
          status: "READY",
          loadedLocales: [...prevState.loadedLocales, locale]
        });
      });
    }).catch((err) => {
      console.error(`can't find ${locale} locale`, err);
      setResourcesState((prevState) => {
        return __spreadProps(__spreadValues({}, prevState), { status: "ERROR" });
      });
    });
  }, [locale, loadedLocales]);
  const t = React.useMemo(() => i18nextInstance.t.bind(i18nextInstance), [i18nextInstance]);
  return /* @__PURE__ */ React.createElement(ContentViewer, __spreadProps(__spreadValues({}, props), { t }));
};
function createI18nextInstance({
  activeLocale,
  resources
}) {
  const resourcesWithNs = Object.keys(resources).reduce((acc, key) => {
    acc[key] = { translation: resources[key] };
    return acc;
  }, {});
  const instance = i18next.createInstance({
    lng: activeLocale,
    keySeparator: "$",
    interpolation: { escapeValue: false },
    resources: resourcesWithNs
  });
  instance.init();
  return instance;
}
function addDefaultsFromEnglish(resources) {
  const english = resources.en;
  return Object.keys(resources).reduce((acc, locale) => {
    acc[locale] = __spreadValues(__spreadValues({}, english), resources[locale]);
    return acc;
  }, {});
}

export { TranslatedContentViewer };
//# sourceMappingURL=TranslatedContentViewer.js.map
